

















































































import template from '@/views/template.vue'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { mall } from '@/mall_jssdk'
import { navigateBackOrTo, navigateTo } from '@/router'
import { openMap } from '@/utils'

type UniStore = {
  id: any
  name: any
  logo: any
  address: any
  contact: any
  latitude: any
  longitude: any
  distance: string
}

// 统一店铺信息数据结构
function makeUniStore(store: any): UniStore {
  return {
    id: store.storeId || store.merchantId,
    name: store.storeName || store.merchantName,
    logo: store.storePic || store.storeLogo,
    address: store.address || store.merchantAddress || store.storeAddress,
    contact: store.storePhone || store.merchantTel || store.contactPhone,
    latitude: store.latitude || store.merchantLatitude,
    longitude: store.longitude || store.merchantLongitude,
    distance: `距离${mall.calculator.div(store.distance || 0, 1000)}km`,
  }
}

export default defineClassComponent<{
  goods: any
  value: any
  showAddress: boolean
  largeName: boolean
  limit: number
  showMore: boolean
}>(
  {
    components: { template },
    props: [
      'goods',
      'value',
      'showAddress',
      'largeName',
      'limit',
      'showMore',
    ],
  },
  ({ props }) =>
    class {
      store = computed(() => ({
        main: makeUniStore(
          Array.isArray(props.value)
            ? props.value[0]
            : props.value.writeOffStores
            ? props.value.store || props.value.writeOffStores[0]
            : props.value,
        ),
        list: (Array.isArray(props.value)
          ? props.value
          : props.value.writeOffStores
          ? props.value.writeOffStores
          : [props.value]
        ).map(makeUniStore),
      }))

      handleStoreClick = (id: string) => {
        if (id) {
          navigateBackOrTo('BookIndex', {
            martId: id,
          })
        }
      }

      handleNavigateClick = (item: UniStore) => {
        openMap({
          name: item.name,
          latitude: item.latitude,
          longitude: item.longitude,
        })
      }

      handleContactClick = (item: UniStore) => {
        dcb.makePhoneCall({
          phoneNumber: item.contact,
        })
      }

      handleCertClick = () => {
        navigateTo('MartCert', {
          id: this.store.value.main.id,
        })
      }

      handleMoreClick = () => {
        navigateTo('BookMartAvailable', {
          id: this.store.value.main.id,
        })
      }
    },
)
